export default __webpack_public_path__ + "images/cc2fa5835790e563a2dd5322f014f7e1-independence_day.jpg";